import { useState } from "react";

const useTagDropdown = (services, agency) => {
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [tagsData, setTagsData] = useState([]);
  const [loadingTag, setLoadingTag] = useState(false);
  const [tagInputs, setTagInputs] = useState({});

  const handleToggle = async (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);

    if (openDropdownIndex !== index && tagsData.length === 0) {
      setLoadingTag(true);
      try {
        const { response } = await services.accounts.getGhlTags({
          query: `agency_id=${agency._id}`,
        });
        if (response) setTagsData(response.data || []);
      } catch (error) {
        console.error("Failed to load tags:", error);
      } finally {
        setLoadingTag(false);
      }
    }
  };

  const handleSelectTag = (index, tag, onTagChange) => {
    if (onTagChange) {
      onTagChange(index, "tag", tag.name);
    }
    setTagInputs((prev) => ({ ...prev, [index]: tag.name }));
    setOpenDropdownIndex(null);
  };

  const handleInputChange = (index, value, onTagChange) => {
    if (onTagChange) {
      onTagChange(index, "tag", value);
    }
    setTagInputs((prev) => ({ ...prev, [index]: value }));
  };

  return {
    openDropdownIndex,
    tagsData,
    loadingTag,
    tagInputs,
    handleToggle,
    handleSelectTag,
    handleInputChange,
  };
};

export default useTagDropdown;
